import { withStyles } from '@material-ui/core';
import RadioButton from './RadioButton';
import styles from './RadioButton.styles';

export default withStyles(styles)(RadioButton);
